"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var polished_1 = require("polished");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BubbleLoader_1 = __importStar(require("./BubbleLoader"));
/**
 * Give Bubbles dimensions to match space taken up in document flow
 */
var BubblesWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* 1px bigger than BubbleLoader to avoid chopping off the bottom */\n  font-size: ", ";\n  height: 2.5em;\n  width: ", "em;\n"], ["\n  /* 1px bigger than BubbleLoader to avoid chopping off the bottom */\n  font-size: ", ";\n  height: 2.5em;\n  width: ", "em;\n"])), function (props) { return "".concat((0, polished_1.rem)(props.size + 1)); }, BubbleLoader_1.SINGLE_BUBBLE_DIAMETER * 3);
/**
 * Our standard loading indicator. Used within pages and components.
 */
var Loader = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? 6 : _b;
    return (react_1.default.createElement(BubblesWrapper, { className: className, size: size },
        react_1.default.createElement(BubbleLoader_1.default, { color: color, size: size })));
};
exports.Loader = Loader;
var templateObject_1;
